import { Button } from "@/components/ui/baseUi/button"
import { useSidebarMenu } from "@/components/ui/layout/menuSidebar/sidebar"
import { HustleupIcon } from "@images/hustleupIcon"
import { cn } from "@modules/lib/utils"
import { MenuIcon } from "lucide-react"

export type MobileTriggerProps = {
  className?: string
} & React.ComponentProps<"div">

export function MobileTrigger({ className, ...props }: MobileTriggerProps) {
  const { openMobile, setOpenMobile } = useSidebarMenu()

  return (
    <div
      className={cn(
        "flex w-full items-start border-b border-borderDefault bg-surface-background shadow-xs md:hidden",
        className,
      )}
      {...props}
    >
      <div className="flex w-full items-center justify-between gap-2 px-6 py-4">
        <Button variant="outline" size="iconMd" onClick={() => setOpenMobile(!openMobile)}>
          <MenuIcon className="size-6" />
        </Button>
        <HustleupIcon color="currentColor" />
      </div>
    </div>
  )
}
